import { ButtonPropsSizeOverrides, ButtonPropsVariantOverrides, Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { OverridableStringUnion } from '@mui/types';
import React from 'react';
import { StyledDocumentButton } from '../../CfDocumentViewer.styles';

export interface CfDocumentViewerDownloadButtonProps {
  fileName: string;
  fileSrc: Blob;
  variant?: OverridableStringUnion<'text' | 'outlined' | 'contained', ButtonPropsVariantOverrides>;
  size?: OverridableStringUnion<'small' | 'medium' | 'large', ButtonPropsSizeOverrides>;
  text?: string;
  sx?: SxProps<Theme>;
}

const CfDocumentViewerDownloadButton: React.FC<CfDocumentViewerDownloadButtonProps> = (
  props: CfDocumentViewerDownloadButtonProps
) => {
  const { fileName, fileSrc } = props;
  const handleClick = () => {
    const link = document.createElement('a');
    link.download = fileName.includes('.pdf') ? fileName : fileName + '.pdf';
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    link.href = URL.createObjectURL(new Blob([fileSrc], { type: 'application/octet-stream' }));
    link.click();
  };

  return (
    <StyledDocumentButton
      variant={props.variant ?? 'contained'}
      color='primary'
      onClick={handleClick}
      size={props.size}
      sx={props.sx}
    >
      {props.text ?? 'Download'}
    </StyledDocumentButton>
  );
};

export default CfDocumentViewerDownloadButton;
